import { render, staticRenderFns } from "./hungJobs.vue?vue&type=template&id=13507860&"
import script from "./hungJobs.vue?vue&type=script&lang=js&"
export * from "./hungJobs.vue?vue&type=script&lang=js&"
import style0 from "./hungJobs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports